import { create } from "zustand";
import { persist } from "zustand/middleware";

interface IPurchaseStore {
  canUseQuickCheckout: boolean;
  purchaseInProgress: boolean;
  setCanUseQuickCheckout(canUse: boolean): void;
  setPurchaseInProgress(inProgress: boolean): void;
}

export const usePurchaseStore = create<IPurchaseStore>()(persist((set) => ({
  canUseQuickCheckout: false,
  purchaseInProgress: false,
  setCanUseQuickCheckout: (canUse: boolean) => set((state) => ({ ...state, canUseQuickCheckout: canUse })),
  setPurchaseInProgress: (inProgress: boolean) => set((state) => ({ ...state, purchaseInProgress: inProgress })),
}), {
  name: "purchase-store",
  // purchaseInProgress only describes the current page's payment attempt, so it
  // must not survive a reload or the processing overlay gets stuck on.
  partialize: ({ canUseQuickCheckout }) => ({ canUseQuickCheckout }),
  // Version 0 persisted purchaseInProgress; drop it from existing browsers.
  version: 1,
  migrate: (persistedState) => ({
    canUseQuickCheckout: (persistedState as Partial<IPurchaseStore> | undefined)?.canUseQuickCheckout ?? false,
  }),
}));

export default usePurchaseStore;
